import { useDispatch } from 'react-redux';
import { captureException } from '@sentry/gatsby';
import { getBranch, getMarket, getServiceInfo, getShowroom, getShowrooms } from '../actions/location-actions';
import { savePostalCode } from '../components/utilities/functions';
import { useCart } from './use-cart';
import { useProduct } from './use-product';

export const useUtilityFunction = () => {
	const dispatch = useDispatch();
	const { getCart } = useCart();
	const { fetchProductTiles } = useProduct();

	const updateLocation = async (value, cart = true, event) => {
		try {
			dispatch(getMarket(value));
			dispatch(getShowroom(value));
			dispatch(getShowrooms(value, event));
			dispatch(getBranch(value));
			dispatch(getServiceInfo(value));
			savePostalCode(value);

			dispatch(fetchProductTiles());
			if (cart) await getCart();
		} catch (error) {
			captureException(error);
		}
	};

	return {
		updateLocation,
	};
};
